module.exports = __webpack_public_path__ + "static/feature3-d267eda349b4befe74bc01fe176a2971.png";